import React from 'react';

const BtnSort = ({
  by,
  query,
  onQuery,
  children,
}) => (
  <button
    className={`btn btn-sm border ${query.sort[by] ? '' : 'text-muted'}`}
    onClick={() => onQuery({
      ...query,
      sort: { [by]: query.sort[by] ? -query.sort[by] : -1 },
    })}
  >
    {children} {query.sort[by] === 1 ? '↑' : '↓'}
  </button>
);

export default BtnSort;
